<p>verify-information-detail-step works!</p>
